import moment from 'moment';

const toMomentDayStart = (date) => {
    if (!date) return null;
    const m = moment(date, 'YYYY-MM-DD', true);
    return m.isValid() ? m.startOf('day').toISOString() : null;
};
const toMomentDayEnd = (date) => {
    if (!date) return null;
    const m = moment(date, 'YYYY-MM-DD', true);
    return m.isValid() ? m.endOf('day').toISOString() : null;
};
export async function createExportTask({ server, dateFrom, dateTo, filterRequest, searchRequest, prefilterRequest, name }) {

    const isoFrom = toMomentDayStart(dateFrom);
    const isoTo = toMomentDayEnd(dateTo);

    const dateFilters = [
        { field: 'dateCreated', op: '>', value: isoFrom },
        { field: 'dateCreated', op: '<', value: isoTo },
    ];
    let filter = [dateFilters];

    if (filterRequest && Array.isArray(filterRequest) && filterRequest.length > 0) {
        // add dateFilters to each group in filterRequest
        filter = filterRequest.map(group => [...group, ...dateFilters]);
    }
    if (searchRequest && searchRequest.length > 0) {
        // add dateFilters to each group in searchRequest
        filter = searchRequest.map(group => [...group, ...dateFilters]);
    }
    const body = {
        filter,
        sort: [{ field: 'id', direction: 'desc' }],
        paging: { page: 0, pageSize: 10000 },
        prefilter: prefilterRequest || [],
    };

    const qs = name && name.trim().length > 0
        ? `?name=${encodeURIComponent(name.trim())}`
        : '';


    let resp;

    resp = await server.exportTask(body, qs);
    if (resp.error !== 'OK') {
        console.log('error response from createExportTask', resp.error);
        throw new Error(resp.message || 'Failed to create export task');
    }
    return resp;
}
